<template>
  <soha-page-loading v-if="loading" />
  <div class="card card-custom gutter-b px-4 px-8 pt-8 pb-0" v-else>
    <soha-no-access
      v-if="!access"
      :message="$t(`${I18nPrefix}ACCESS_MESSAGE`)"
    />
    <div v-else>
      <div class="mb-3">
        <span class="soha-page-title">
          {{ $t(`${I18nPrefix}PAGE_TITLE`) }}
        </span>
      </div>
      <div class="w-100 w-md-50 mx-0 mx-md-auto">
        <soha-alert
          v-if="showDangerAlert"
          variant="danger"
          @onDismissClicked="showDangerAlert = false"
          dismissible
        >
          <div>
            <span class="d-block font-weight-bolder">
              {{ $t(`${I18nPrefix}PAYMENT_FAILED`) }}
            </span>
            <p class="pt-3 mb-0">
              {{ $t(`${I18nPrefix}RETURNED_TO_ACCOUNT`) }}
            </p>
          </div>
        </soha-alert>
      </div>
      <div class="card card-custom gutter-b p-8 mx-auto mb-5 col-md-6 col-12">
        <div>
          <soha-text-field
            class="w-100"
            :error="amount.error"
            :placeholder="$t(`${I18nPrefix}AMOUNT`)"
            v-model.trim="amount.value"
            @onEnterPressed="saleAmount()"
            name="amount"
          />
        </div>
        <div class="my-5">
          <soha-select
            class="w-100"
            name="paymentGateway"
            :options="paymentGateways"
            :placeholder="$t(`${I18nPrefix}PAYMENT_GATEWAY`)"
            v-model="paymentGateway"
          />
        </div>

        <div>
          <soha-alert variant="secondary" v-if="!amount.value">
            <p class="text-justify line-height-xl mb-0">
              {{ $t(`${I18nPrefix}CHARGE_DESCRIPTION`) }}
            </p>
          </soha-alert>
          <div class="soha-payment-invoice" v-else>
            <div class="row m-0">
              <div class="col-6 mb-1 d-flex align-items-center">
                {{ $t(`${I18nPrefix}AMOUNT`) }}
              </div>
              <div
                class="col-6 mb-1 d-flex justify-content-end align-items-center"
              >
                {{ toLocaleStringAmount }}
                {{ $t(`${I18nPrefix}RIAL`) }}
              </div>
              <div class="col-6 mb-4 d-flex align-items-center">
                {{ $t(`${I18nPrefix}VAT`) }}
              </div>
              <div
                class="col-6 mb-4 d-flex justify-content-end align-items-center"
              >
                {{ toLocaleStringVat }}
                {{ $t(`${I18nPrefix}RIAL`) }}
              </div>
              <div class="col-6 d-flex align-items-center font-weight-bolder">
                {{ $t(`${I18nPrefix}AMOUNT_PAY`) }}
              </div>
              <div class="col-6 d-flex justify-content-end align-items-center">
                <span class="font-weight-bolder primary-color font-size-h4">
                  {{ toPersianDigits(amountPay.toLocaleString()) }}
                  {{ $t(`${I18nPrefix}RIAL`) }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div>
          <soha-button
            class="w-100"
            name="saleAmount"
            @click="saleAmount()"
            :text="$t(`${I18nPrefix}PAYMENT`)"
            :loading="btnLoading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIMixin from "@/mixins/UIMixin";
import ValidationMixin from "@/mixins/ValidationMixin";
import ApiService from "@/core/services/api.service";
import { mapGetters } from "vuex";
export default {
  name: "walletCharge",

  mixins: [UIMixin, ValidationMixin],

  data() {
    return {
      I18nPrefix: "PAGES.FINANCIAL.WALLET_CHARGE.",
      loading: false,
      btnLoading: false,
      access: true,
      vat: null,
      amount: {
        value: null,
        error: null,
      },
      showDangerAlert: false,
      paymentGateway: "aqayepardakht",
      paymentGateways: [
        {
          id: "aqayepardakht",
          text: "پرداخت الکترونیک آقای پرداخت",
        },
      ],
    };
  },

  mounted() {
    this.getVat();
    this.showDangerAlert = this.$route.query.gateway;
  },

  methods: {
    getVat() {
      this.loading = true;
      ApiService.get(`api/v2/vat`).then((data) => {
        if (!data.code) {
          this.vat = data.data.vat;
        } else {
          this.errorToast(data.data.message);
        }
        this.loading = false;
      });
    },

    notValidAmount() {
      if (!this.amount.value) {
        this.amount.error = this.validateField(
          this.amount.value,
          this.$t(`${this.I18nPrefix}AMOUNT`)
        );
      } else {
        this.amount.error =
          this.amount.value < 10000 || this.amount.value > 1810000000
            ? this.$t(`${this.I18nPrefix}NO_VALID_AMOUNT`)
            : null;
      }
      return this.amount.error;
    },

    saleAmount() {
      if (this.notValidAmount()) return;
      this.btnLoading = true;
      ApiService.post(`api/v2/invoices/wallet/charge`, {
        amount: this.amount.value,
        gateway: this.paymentGateway,
      })
        .then((data) => {
          if (data.data.action) {
            window.location.href = `https://soha-hr.ir/payment.php?url=${data.data.action}`;
          } else {
            this.errorToast(data.data.message);
          }
          this.btnLoading = false;
        })
        .catch(() => {
          this.errorToast("خطا در ارتباط با درگاه پرداخت");
          this.btnLoading = false;
        });
    },
  },

  computed: {
    ...mapGetters(["companyId"]),

    amountPay() {
      return +this.amount.value * +this.vat + +this.amount.value;
    },

    toLocaleStringAmount() {
      let amount = +this.amount.value;
      return this.toPersianDigits(amount.toLocaleString());
    },

    toLocaleStringVat() {
      return this.toPersianDigits(
        (+this.amount.value * +this.vat).toLocaleString()
      );
    },
  },
};
</script>

<style scoped>
.soha-payment-invoice {
  border: 0.077rem solid var(--light-secondary-color);
  border-radius: 0.385rem;
  padding: 0.769rem 0.385rem;
  background-color: var(--light-secondary-color);
  margin-bottom: 1.923rem;
}
</style>
